import { supabase } from '../supabase'

export const AUDIT_ACTION = {
  LOGIN: 'login',
  LOGOUT: 'logout',
  LOGIN_FAIL: 'login_fail',
  ASSET_CREATE: 'asset_create',
  ASSET_UPDATE: 'asset_update',
  ASSET_DELETE: 'asset_delete',
  ASSET_IMPORT: 'asset_import',
  ASSET_EXPORT: 'asset_export',
  STAFF_IMPORT: 'staff_import',
  STAFF_EXPORT: 'staff_export',
}

export const ACTION_LABELS = {
  login: '登录',
  logout: '退出',
  login_fail: '登录失败',
  asset_create: '新增设备',
  asset_update: '编辑设备',
  asset_delete: '删除设备',
  asset_import: '导入设备',
  asset_export: '导出设备',
  staff_import: '导入员工',
  staff_export: '导出员工',
}

function operatorFields(user) {
  return {
    operator_email: user?.email || '',
    operator_name: user?.displayName || user?.email || '',
    role: user?.role || '',
    hotel: user?.hotel || null,
  }
}

export async function logLogin(user, { success = true, message = '' } = {}) {
  try {
    await supabase.from('login_logs').insert([{
      email: user?.email || '',
      display_name: user?.displayName || null,
      role: user?.role || null,
      hotel: user?.hotel || null,
      success,
      message: message || null,
    }])
  } catch (e) {
    console.warn('login_logs:', e.message)
  }
}

export async function logLoginAttempt(email, { success = false, message = '' } = {}) {
  try {
    await supabase.from('login_logs').insert([{
      email: email?.trim().toLowerCase() || '',
      display_name: null,
      role: null,
      hotel: null,
      success,
      message: message || null,
    }])
  } catch (e) {
    console.warn('login_logs:', e.message)
  }
}

export async function logOperation(user, action, { targetType = '', targetId = '', detail = '' } = {}) {
  if (!user?.email) return
  try {
    const detailStr = typeof detail === 'string' ? detail : JSON.stringify(detail)
    await supabase.from('operation_logs').insert([{
      ...operatorFields(user),
      action,
      target_type: targetType || null,
      target_id: targetId ? String(targetId) : null,
      detail: detailStr || null,
    }])
  } catch (e) {
    console.warn('operation_logs:', e.message)
  }
}

export async function fetchLoginLogs({ limit = 200 } = {}) {
  const { data, error } = await supabase
    .from('login_logs')
    .select('*')
    .order('created_at', { ascending: false })
    .limit(limit)
  if (error) throw error
  return data || []
}

export async function fetchOperationLogs({ limit = 300, hotel } = {}) {
  let q = supabase.from('operation_logs').select('*').order('created_at', { ascending: false }).limit(limit)
  if (hotel) q = q.eq('hotel', hotel)
  const { data, error } = await q
  if (error) throw error
  return data || []
}
